var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApolloQuery',{attrs:{"query":_vm.query,"variables":_vm.variables,"fetchPolicy":"cache-first"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.result.data;
return [(!data)?[_c('div',{staticClass:"loading-wrapper"},[_c('Loading')],1)]:[_vm._t("default",null,null,data)]]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }